// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2Y4yR","content":"Consent_content__2GT1a","footer":"Consent_footer__3DW5V"};